import { ConvertUtils as CoreConverUtils } from "@dooboostore/core";
var ConvertUtils;
((ConvertUtils2) => {
  ConvertUtils2.coreConvertUtils = CoreConverUtils;
  function toObject(data) {
    const formData = new FormData(data);
    const obj = {};
    formData.forEach((value, key) => {
      obj[key] = value;
    });
    return obj;
  }
  ConvertUtils2.toObject = toObject;
  function toObjectUrl(data) {
    return URL.createObjectURL(data);
  }
  ConvertUtils2.toObjectUrl = toObjectUrl;
  ConvertUtils2.isImageConvertConfig = (data) => {
    return typeof data === "object" && data !== null && typeof data.type === "string";
  };
  ConvertUtils2.toFile = async (imageBitmapOrCanvas, config) => {
    const fileName = config.filename;
    delete config["filename"];
    return new File([await ConvertUtils2.toBlob({ data: imageBitmapOrCanvas, config })], fileName, { type: config.type });
  };
  ConvertUtils2.toArrayBuffer = async (imageBitmapOrCanvas) => {
    if (imageBitmapOrCanvas instanceof File) {
      return imageBitmapOrCanvas.arrayBuffer();
    }
    return await (await ConvertUtils2.toBlob({ data: imageBitmapOrCanvas.data, config: imageBitmapOrCanvas.config })).arrayBuffer();
  };
  ConvertUtils2.toBlob = async (imageBitmapOrCanvas) => {
    if (imageBitmapOrCanvas instanceof File) {
      return imageBitmapOrCanvas;
    }
    let canvas;
    if (imageBitmapOrCanvas.data instanceof ImageBitmap || imageBitmapOrCanvas.data instanceof HTMLImageElement) {
      canvas = document.createElement("canvas");
      canvas.width = imageBitmapOrCanvas.data.width;
      canvas.height = imageBitmapOrCanvas.data.height;
      const context = canvas.getContext("2d");
      context.drawImage(imageBitmapOrCanvas.data, 0, 0);
    } else {
      canvas = imageBitmapOrCanvas.data;
    }
    return new Promise((resolve, reject) => {
      try {
        if (canvas instanceof OffscreenCanvas) {
          return canvas.convertToBlob({ type: imageBitmapOrCanvas.config.type, quality: imageBitmapOrCanvas.config.quality });
        } else {
          canvas.toBlob((blob) => {
            if (blob) {
              resolve(blob);
            } else {
              reject(new Error("Blob \uC0DD\uC131 \uC2E4\uD328"));
            }
          }, imageBitmapOrCanvas.config.type, imageBitmapOrCanvas.config.quality);
        }
      } catch (e) {
        reject(e);
      }
    });
  };
  ConvertUtils2.toBase64 = async (imageBitmapOrCanvas, config) => {
    const target = imageBitmapOrCanvas instanceof Promise ? await imageBitmapOrCanvas : imageBitmapOrCanvas;
    if (target instanceof Blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = () => reject(new Error("\uD30C\uC77C \uC77D\uAE30 \uC2E4\uD328"));
        reader.readAsDataURL(target);
      });
    }
    let canvas;
    if (target instanceof ImageBitmap || target instanceof HTMLImageElement) {
      canvas = document.createElement("canvas");
      canvas.width = target.width;
      canvas.height = target.height;
      const context = canvas.getContext("2d");
      context.drawImage(target, 0, 0);
    } else {
      canvas = target;
    }
    return new Promise((resolve, reject) => {
      try {
        if (canvas instanceof OffscreenCanvas) {
          const blob = canvas.convertToBlob({ type: config.type, quality: config.quality });
          if (blob) {
            const reader = new FileReader();
            reader.onloadend = () => {
              resolve(reader.result);
            };
            reader.onerror = (error) => {
              reject(new Error("Blob\uC744 base64\uB85C \uBCC0\uD658\uD558\uB294 \uC911 \uC624\uB958 \uBC1C\uC0DD: " + error));
            };
            reader.readAsDataURL(blob);
          } else {
            reject(new Error("Blob \uC0DD\uC131 \uC2E4\uD328"));
          }
        } else {
          const base64String = canvas.toDataURL(config.type, config.quality);
          resolve(base64String);
        }
      } catch (e) {
        reject(e);
      }
    });
  };
  function toImageBitmap(target) {
    return createImageBitmap(target);
  }
  ConvertUtils2.toImageBitmap = toImageBitmap;
  ConvertUtils2.toBlobURL = async (imageBitmapOrCanvas) => {
    const blob = await (0, ConvertUtils2.toBlob)(imageBitmapOrCanvas);
    return ConvertUtils2.toObjectUrl(blob);
  };
  ConvertUtils2.compressImageToBase64 = async (img, config) => {
    const imageBitmapOrCanvas = await ConvertUtils2.compressImage(img, config);
    return ConvertUtils2.toBase64(imageBitmapOrCanvas, config);
  };
  async function compressImage(img, config) {
    if (img instanceof File) {
      img = await ConvertUtils2.toImageBitmap(img);
    }
    const target = img;
    return new Promise((resolve, reject) => {
      const MAX_WIDTH = config.maxWidth;
      let width = target.width;
      let height = target.height;
      if (width > MAX_WIDTH) {
        height = MAX_WIDTH / width * height;
        width = MAX_WIDTH;
      }
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      canvas.width = width;
      canvas.height = height;
      ctx.drawImage(target, 0, 0, width, height);
      if ((0, ConvertUtils2.isImageConvertConfig)(config)) {
        canvas.toBlob(async (blob) => {
          resolve(blob);
        }, config.type, config.quality);
      } else {
        resolve(createImageBitmap(canvas));
      }
    });
  }
  ConvertUtils2.compressImage = compressImage;
  function decodeHtmlEntity(html, doc) {
    const textarea = doc.createElement("textarea");
    textarea.innerHTML = html;
    return textarea.value;
  }
  ConvertUtils2.decodeHtmlEntity = decodeHtmlEntity;
})(ConvertUtils || (ConvertUtils = {}));
export {
  ConvertUtils
};
//# sourceMappingURL=ConvertUtils.js.map
